// removed by extract-text-webpack-plugin
module.exports = {"outer":"_2DVC"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Messages/MessageLog/MessageLog.scss
// module id = Ryba
// module chunks = 0